import { mapGetters } from 'vuex';

export function mapGettersTyped<T, K extends keyof T & string = keyof T & string>(
  getters: K[],
): Pick<T, K> {
  return mapGetters(getters) as Pick<T, K>;
}
